import { LOCATION_CHANGE } from 'connected-react-router'

const initialState: App.RouteHistoryState = {
  previous: null,
  previousSearch: null,
  search: null,
  current: null,
}

export default function routeHistoryReducer(state = initialState, action): App.RouteHistoryState {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (action.payload.location.pathname === state.current) {
        return state
      }

      return {
        previous: state.current,
        previousSearch: state.search,
        search: action.payload.location.search,
        current: action.payload.location.pathname,
      }
    default:
      return state
  }
}
